import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useTheme } from "@mui/material";

/**
 * Barra de progresso fina no topo da viewport (estilo nprogress), zero-dep.
 * Ferramenta de PERCEPÇÃO: a cada troca de rota reinicia uma animação CSS
 * que avança rápido até ~90% e desaparece. CSS keyframes (não estado React
 * + setInterval) garante que o movimento aconteça mesmo com o
 * startTransition do router despriorizando updates — e é mais suave.
 *
 * O `key` muda a cada rota, forçando o React a remontar o elemento e o
 * browser a reiniciar a animação do zero.
 */
const DURACAO_MS = 800;

function TopProgressBar() {
  const location = useLocation();
  const theme = useTheme();
  const [runId, setRunId] = useState(0);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setRunId((n) => n + 1);
    setVisible(true);
    const t = window.setTimeout(() => setVisible(false), DURACAO_MS);
    return () => window.clearTimeout(t);
  }, [location.pathname]);

  if (!visible) return null;

  const cor = theme.palette.primary.main;

  return (
    <>
      <style>{`
        @keyframes topbar-avanca {
          0%   { width: 0%;   opacity: 1; }
          70%  { width: 90%;  opacity: 1; }
          100% { width: 100%; opacity: 0; }
        }
      `}</style>
      <div
        key={runId}
        aria-hidden
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          height: 3,
          zIndex: theme.zIndex.appBar + 2,
          backgroundColor: cor,
          boxShadow: `0 0 8px ${cor}, 0 0 4px ${cor}`,
          pointerEvents: "none",
          animation: `topbar-avanca ${DURACAO_MS}ms ease-out forwards`,
        }}
      />
    </>
  );
}

export default TopProgressBar;
